import {
  AfterViewInit,
  Component,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { WhitepaperspageService } from '../../whitepaperspage.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-whitepaper-article-apply',
  templateUrl: './whitepaper-article-apply.component.html',
  styleUrls: ['./whitepaper-article-apply.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class WhitepaperArticleApplyComponent
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  @Input() pageData: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private posthogService: PosthogService
  ) {
    this.subscriptions = [];
    this.form = this.formBuilder.group({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      companyWebsite: new FormControl('', [
        Validators.required,
        Validators.pattern(this.websiteRegexp),
      ]),
      companyEmail: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegexp),
      ]),
      cCode: new FormControl('', [Validators.required]),
      company_turnover: new FormControl('', []),
      jobFunction: new FormControl('', []),
      subscribe: new FormControl(),
    });
  }

  form: FormGroup;
  emptyForm: boolean = false;
  public formValueChangeSubscription!: Subscription;
  emailRegexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  websiteRegexp =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
  applyFormData = {
    name: '',
    countryCode: '',
    companyWebsite: '',
    companyEmail: '',
    company_turnover: '',
    job_function: '',
    fromWebsite: true,
    subscribe: false,
  };

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  applyData: any;
  formSubmitted: boolean = false;

  ngOnInit(): void {
    // let data = this.route.snapshot.data?.['articleContent']?.[0]?.fields;
    // if (data != null) {
    //   this.applyData = {
    //     formId: data.applyPanel.fields.component1[0].fields?.formId,
    //     header: data.applyPanel.fields.title,
    //     paragraph: data.applyPanel.fields.content,
    //     downlodFile: data.whitepaperAndReportsDownloadFile.fields.file.url,
    //   };
    // }

    // this.formValueChangeSubscription = this.form.valueChanges.subscribe(() => {
    //   this.emptyForm = Object.keys(this.form.controls).some(
    //     formKey => this.form.controls[formKey].value
    //   );
    // });
  }
  ngOnChanges(): void {
    let data = this.pageData?.fields;
    if (data != null) {
      this.applyData = {
        formId: data?.applyPanel?.fields?.component1?.[0]?.fields?.formId,
        header: data?.applyPanel?.fields?.title,
        paragraph: data?.applyPanel?.fields?.content,
        downlodFile: data?.whitepaperAndReportsDownloadFile?.fields?.file?.url,
      };
    }

    this.formValueChangeSubscription = this.form.valueChanges.subscribe(() => {
      this.emptyForm = Object.keys(this.form.controls).some(
        formKey => this.form.controls[formKey].value
      );
    });
  }
  getFormId() {
    return this.applyData.formId
      ? this.applyData.formId
      : '77420a33-602e-4f68-8029-3b8b7e6f6c8e';
  }
  ngAfterViewInit() {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    try {
      // @ts-ignore
      hbspt.forms.create({
        region: 'na1',
        portalId: '8646839',
        formId: '77420a33-602e-4f68-8029-3b8b7e6f6c8e',
        target: '#hubspotDownloadForm',
        onFormReady: function ($form:any) {
          const fieldsets = $form[0].querySelectorAll('div.input');

          const submitButton = $form.find('input[type="submit"].hs-button');
          submitButton.css({
            padding: '16px',
            'border-radius': '10px',
            background: ' #359EB4',
            height: '48px',
            'font-size': '15px',
            'font-weight': '600',
            border: 'none',
            width: '100%',
          });
          submitButton.hover(
            function () {
              submitButton.css('background-color', '#2a7e90');
            },
            function () {
              submitButton.css('background-color', '#359eb4');
            }
          );
          const allInputs = $form[0].querySelectorAll('.hs-input');
          allInputs.forEach((input:any) => {
            if (input.type != 'checkbox') {
              input.style.height = '48px';
              input.style.borderRadius = '10px';
              input.style.border = '1px solid #E6E7E9';
              input.style.background = '#FFF';
            }
          });
        },
        onFormSubmit: () => {
          window.open(`http:${this.applyData.downlodFile}`);
        },
        onFormSubmitted: () => {
          const pathSegments = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
          const whitepaperTitle = pathSegments[pathSegments.length - 1] || '';
          this.posthogService.capture('form_whitepaper_submitted', {
            form_type: 'whitepaper_download',
            hubspot_form_id: '77420a33-602e-4f68-8029-3b8b7e6f6c8e',
            whitepaper_title: whitepaperTitle,
            page_url: window.location.href,
          });
        },
      });
    } catch (_) {}
  }
}
